/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import { API_URL, BASE_URL } from '../constants'
import { logout } from './Common'
const axios = require('axios')

export function setCookie(name, value, time) {
  var expires = ''
  if (time) {
    var date = new Date()
    date.setTime(date.getTime() + time * 1000)
    expires = '; expires=' + date.toUTCString()
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/'
}

export function getLocalStorageData(name) {
  let encodedString = localStorage.getItem(name)
  if (encodedString === null) {
    return encodedString
  } else {
    let decodedString = atob(encodedString)
    return decodedString
  }
}

export function getUserId() {
  return JSON.parse(getLocalStorageData('userInfo'))['id']
}

export function isSuperUser() {
  return (
    JSON.parse(getLocalStorageData('userInfo'))['userlevel'] === 'superadmin'
  )
}
export function getCurrentUserDepartment() {
  return JSON.parse(getLocalStorageData('departmentInfo'))
}

export function getCurrentUserEconomicYear() {
  return JSON.parse(getLocalStorageData('functionalYearInfo'))[
    'functionalyearid'
  ]
}
export function getCurrentUserEconomicYearObject() {
  return JSON.parse(getLocalStorageData('functionalYearInfo'))
}
export function getCurrentUserBranch() {
  return JSON.parse(getLocalStorageData('branchInfo'))
}

export function getCookie(name) {
  var nameEQ = name + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    // eslint-disable-next-line eqeqeq
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

export function eraseCookie(name) {
  setCookie(name, '', 1)
}

export function getAccessToken() {
  console.log('getAccesstoken')
  return new Promise((resolve) => {
    let erp_refresh_token = getCookie('erp_refresh_token')
    let clientId = getCookie('apikey')

    var auth = {
      auth: {
        username: clientId,
        password: 'infoxerp@123',
      },
    }
    var loginUrl = `${API_URL}oauth/token?erp_refresh_token=${erp_refresh_token}&grant_type=erp_refresh_token`
    axios
      .post(loginUrl, {}, auth)
      .then(async (response) => {
        let resp = await resetAccessToken(response)
        if (resp) {
          resolve(true)
        }
      })
      .catch(async (err, code) => {
        if (err.message === 'Request aborted') {
          window.location.reload()
          return
        } else {
          logout()
        }
        // alert(
        //   'System is currently in maintenance mode. Sorry for inconvenience'
        // ) //noneed
      })
  })
}

export function resetAccessToken(response) {
  return new Promise((resolve) => {
    if (response.status === 200) {
      setCookie(
        'erp_access_token',
        response.data.access_token,
        response.data.expires_in
      )
      setCookie(
        'erp_token_type',
        response.data.token_type,
        response.data.expires_in
      )
      setCookie('erp_refresh_token', response.data.refresh_token)
      setCookie(
        'erp_expires_in',
        response.data.expires_in,
        response.data.expires_in
      )
      resolve(true)
    } else {
      // alert('System is currently in maintenance mode. Sorry for inconvenience') //noneed
      logout()
    }
  })
}

export function getUserInfo() {
  return getCookie('username')
}
//
